import { defineComponent as _defineComponent } from 'vue'
import UserBreadcrumb from "@/components/common/UserBreadcrumb.vue";
import AccountSelectModal from "@/components/modules/account/AccountSelectModal.vue";
import AccountSelectSearch from "@/components/modules/account/AccountSelectSearch.vue";
import Tabs from "@/components/common/Tabs.vue";

import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Payment',
  setup(__props) {

const route = useRoute();
const router = useRouter();


const showAccountSelectionModal = ref(false);

const { $t } = useTranslation();

const tabs = [
  { id: "profile-payment", name: $t("Collection") },
  { id: "profile-payment-history", name: $t("Credit History") },
];

const selectedTab = computed({
  get() {
    return route.name || tabs[0].id;
  },
  set(value: string) {
    router.push({ name: value, query: route.query });
  },
});

function handleInput(value: string) {
  selectedTab.value = value;
}

return { __sfc: true,route, router, showAccountSelectionModal, $t, tabs, selectedTab, handleInput, UserBreadcrumb, AccountSelectModal, AccountSelectSearch, Tabs }
}

})